import { createSlice } from "@reduxjs/toolkit";
import { DeliveryDetailsData } from "utils/types";

interface DeliveryChargesSettingsTypes {
  selectedDeliveryBranch: DeliveryDetailsData | {};
}

// initial state
const initialState: DeliveryChargesSettingsTypes = {
  selectedDeliveryBranch: {},
};

const DeliveryChargesSettings = createSlice({
  name: "deliveryChargesSettings",
  initialState,
  reducers: {
    setSelectedDeliveryBranch(state, action) {
      state.selectedDeliveryBranch = { ...action.payload };
    },
    resetSelectedDeliveryBranch(state) {
      state.selectedDeliveryBranch = {};
    },
    setChargesDetails(state, action) {
      state.selectedDeliveryBranch = {
        ...state.selectedDeliveryBranch,
        charges_details: {
          ...(state.selectedDeliveryBranch as DeliveryDetailsData)
            .charges_details,

          [action.payload.type]: action.payload.value,
        },
      };
    },
    setWeightDetails(state, action) {
      state.selectedDeliveryBranch = {
        ...state.selectedDeliveryBranch,
        charges_details: action.payload,
      };
    },
  },
});

export default DeliveryChargesSettings.reducer;

export const {
  setSelectedDeliveryBranch,
  resetSelectedDeliveryBranch,
  setChargesDetails,
  setWeightDetails,
} = DeliveryChargesSettings.actions;
